import { render, staticRenderFns } from "./MiniBagEmpty.vue?vue&type=template&id=1975ce62&"
import script from "./MiniBagEmpty.vue?vue&type=script&lang=js&"
export * from "./MiniBagEmpty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIconEmptyBag: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/svg/IconEmptyBag.vue').default})
